import {Component, inject} from '@angular/core'
import {MatButton} from '@angular/material/button'
import {ConfigService} from '@sparbanken-syd/sparbanken-syd-bankid'
import {RoleHelper} from '../../services/role-helper'
import {PromiseListComponent} from './promise-list/promise-list.component'
import {StatisticsComponent} from './statistics/statistics.component'

export type TViewType = 'list' | 'contact'

@Component({
  selector: 'spb-admin-content',
  templateUrl: './admin-content.component.html',
  styleUrl: './admin-content.component.scss',
  imports: [
    StatisticsComponent,
    MatButton,
    PromiseListComponent
  ]
})
export class AdminContentComponent {
  public readonly helper = inject(RoleHelper)
  public viewType: TViewType = 'list'
  protected readonly configService = inject(ConfigService)
}
